import React, { Component } from 'react';
import classes from './OtpVerification.css';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import Modal from '../../../../UI/Modal/Modal';
import { checkSuperUser, checkSuperVisorUser, checkValidity, decodeBase64, isPartialRegistration } from '../../../../shared/utility';
import Message from '../../../../components/Message/Message';
import GenerateOTP from './GenerateOTP';
import { SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER, LS_DISABLE_IDENTITY_ATTEST_FAIL, LS_OTP_VERIFIED, HSID_BASE, HSID_PARTIAL_REGISTRATION } from '../../../../shared/Constants';


class VerifyOTP extends Component {
    state = {
        showModal: false,
        verifyOtpForm: {
            otpCode: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'otpCode',
                    minLength: 6,
                    maxLength: 10,
                    pattern: '[0-9]{1,10}',
                    title: 'OTP code can only contain numbers'
                },
                value: '',
                validation: {
                    required: true,
                    minlength: 6,
                    maxlength: 10,
                },
                disabled: false,
                valid: true,
                touched: false,
                inputType: "OneThirdInlineBlockOtp",
            }
        },
        disableOtp: true,
        otpTypeSelectValue: 'Phone',
        otherFormDetails: {
            firstName: this.props.essoData.firstName,
            lastName: this.props.essoData.lastName,
            countryCode: this.props.essoData.phone?.countryCode,
            phoneNumber: this.props.essoData.phone?.number,
        },
        idType: this.props.idType
    }

    inputChangedHandler = (event, inputIdentifier) => {

        let checkOtpSize = true;

        let updatedForm = { ...this.state.verifyOtpForm };

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        if (inputIdentifier === 'otpCode') {
            checkOtpSize = this.checkOtpLength(updatedFormElement.value);
        }
        let formIsValid = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        if (event.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
        } else {
            updatedFormElement.valid = false;
        }

        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({ verifyOtpForm: updatedForm, formIsValid: formIsValid, disableOtp: checkOtpSize });
    }

    checkOtpLength = (otpCode) => {
        return otpCode.length < 6 ? true : false;
    }

    setOtpType = (otpType) => {
        this.setState({ otpTypeSelectValue: otpType });
    }

    setOtherFormDetails = (formDetails) => {
        this.setState({
            otherFormDetails:
            {
                ...this.state.otherFormDetails,
                ...formDetails
            }
        })
    }

    verifyOtpTokenHandler = (event) => {
        event.preventDefault();
        const uuid2StepFailed = this.getOtpVerifiedUuidWithFail() === this.props.essoData.uuid;
        if((this.props.isOTPVerified && !(checkSuperUser(this.props.userType) || checkSuperVisorUser(this.props.userType))) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) ) {
            return;
        }
        if (this.props.genTokenResponse && this.props.genTokenResponse.sessionid) {
            if (this.state.otpTypeSelectValue === 'Phone' || this.state.otpTypeSelectValue === 'Call') {
                let formData = {
                    sessionid: this.props.genTokenResponse.sessionid,
                    transactionid: this.props.genTokenResponse.transactionid,
                    username: this.props.genTokenResponse.uuid,
                    phoneno: this.state.otherFormDetails.phoneNumber && this.state.otherFormDetails.phoneNumber !== this.props.essoData.phone.number ?
                        this.state.otherFormDetails.phoneNumber : this.props.essoData.phone.number,
                    homePhone: this.props.essoData.phone.label === 'MOBILE' ? true : false,
                    token: this.state.verifyOtpForm['otpCode'].value,
                    phoneProviderSessionId: this.props.genTokenResponse.phoneProviderSessionId,
                    userId: this.props.essoData.userName,
                    countryCode: this.state.otherFormDetails.countryCode && this.state.otherFormDetails.countryCode !== this.props.essoData.phone.countryCode
                        ? this.state.otherFormDetails.countryCode : this.props.essoData.phone?.countryCode,
                    essoNumber: this.props.essoData.phone?.number,
                    essoCountryCode: this.props.essoData.phone?.countryCode,
                }
                if (this.state.otherFormDetails.firstName && this.state.otherFormDetails.firstName !== this.props.essoData.firstName) {
                    formData.firstName = this.state.otherFormDetails.firstName
                }
                if (this.state.otherFormDetails.lastName && this.state.otherFormDetails.lastName !== this.props.essoData.lastName) {
                    formData.lastName = this.state.otherFormDetails.lastName
                }
                this.props.verifySmsOtpToken(formData, {
                    uuid: this.props.essoData.uuid, idType: this.props.idType,
                    phoneno: this.props.essoData.phone?.number, countryCode: this.props.essoData.phone?.countryCode
                });
            }
            else {
                let formData = {
                    sessionid: this.props.genTokenResponse.sessionid,
                    transactionid: this.props.genTokenResponse.transactionid,
                    username: this.props.genTokenResponse.uuid,
                    token: this.state.verifyOtpForm['otpCode'].value,
                    phoneProviderSessionId: this.props.genTokenResponse.phoneProviderSessionId,
                    userId: this.props.essoData.userName,
                    countryCode: this.props.essoData.phone?.countryCode
                }
                this.props.verifyEmailOtpToken(formData);
            }
        } else {
            this.props.setOtpDisplayMessage({ type: "Error", info: { message: "Wrong Code" } });
        }
    }

    handleAttest = (flag) => {
        const data = {
            uuid: this.props.genTokenResponse?.uuid || this.props.essoData.uuid,
            phoneno: this.state.otherFormDetails.phoneNumber && this.state.otherFormDetails.phoneNumber !== this.props.essoData.phone.number ?
                this.state.otherFormDetails.phoneNumber : this.props.essoData.phone.number,
            username: this.props.essoData.userName,
            countryCode: this.state.otherFormDetails.countryCode && this.state.otherFormDetails.countryCode !== this.props.essoData.phone.countryCode
                ? this.state.otherFormDetails.countryCode : this.props.essoData.phone?.countryCode,
            event: 'TWO_STEP_ATTESTATION',
            eventStatus: flag ? 'SUCCESS' : 'FAILURE',
            newData: { NewUI: "No" }
        }
        this.props.initiateAttest(data, this.props.essoData, this.props.userType)
        this.setState({ showModal: false })
    }

    getOtpVerifiedUuidWithFail() {
        const uuid = decodeBase64(localStorage.getItem(LS_DISABLE_IDENTITY_ATTEST_FAIL));
        return uuid
    }

    getOtpVerifiedUuid() {
        const uuid = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED));
        return uuid
    }

    render() {

        const shouldHideTwoStepAttestation = [
            HSID_BASE,
            HSID_PARTIAL_REGISTRATION
        ].includes(this.state.idType)

        const formsElementsArray = [];

        for (let key in this.state.verifyOtpForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.verifyOtpForm[key]
            });
        }

        let verifyOtpForm = (
            <>
                <form onSubmit={this.verifyOtpTokenHandler}>
                    <div className={classes.RowSplit}>
                        {formsElementsArray.map(formElement => (
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                disabled={formElement.config.disabled}
                                label={formElement.config.label}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                inputType={formElement.config.inputType}
                                tabIndex={(this.props.isOTPVerified && !(checkSuperUser(this.props.userType) || checkSuperVisorUser(this.props.userType))) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) ? -1 : 0}
                            />
                        ))}
                        <Button id="confirm" btnType="ConfirmOTP" disabled={this.state.disableOtp || this.props.otpGenerated ||
                            this.props.disableConfirm
                        }>Confirm</Button>
                    </div>
                </form>

                { (!shouldHideTwoStepAttestation && [SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER].includes(this.props.userType)) &&
                    <div className={classes.attestContainer}>
                        <Button id="attestfail" btnType="AttestFail" type="button" disabled={!this.props.enableAttest && 
                            ![SESSION_SUPERUSER, SESSION_SUPERVISORUSER].includes(this.props.userType)
                        }
                            clicked={() => {
                                if((this.props.isOTPVerified && !(checkSuperUser(this.props.userType) || checkSuperVisorUser(this.props.userType))) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) ) {
                                        return;
                                }
                                this.handleAttest(false)
                            }}
                        ><i>2-step Failed</i></Button>
                        <Button id="attestsuccess" btnType="AttestSuccess" type="button" disabled={!this.props.enableAttest &&
                            ![SESSION_SUPERUSER, SESSION_SUPERVISORUSER].includes(this.props.userType)
                        }
                            clicked={() => {
                                if((this.props.isOTPVerified && !(checkSuperUser(this.props.userType) || checkSuperVisorUser(this.props.userType))) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) ) {
                                        return;
                                }
                                this.setState({showModal: true})
                            }}
                        ><i>I Attest caller passed 2-Step Process</i></Button>
                    </div>}
            </>
        );

        const uuid2StepFailed = this.getOtpVerifiedUuidWithFail() === this.props.essoData.uuid;
        const uuid2StepSuccess = this.getOtpVerifiedUuid() === this.props.essoData.uuid
        const errorMessage = this.props.smsOtpMessage ? <Message msgType={this.props.smsOtpMessage.type} info={this.props.smsOtpMessage.info}
            position={classes.messageContainer} /> : null;
        return (
            <React.Fragment>
                <div className={classes.FormTitle}>Identity Confirmation</div>
                {(this.props.isOTPVerified && (!checkSuperUser(this.props.userType) && SESSION_SUPERVISORUSER !== this.props.userType)) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) 
                // || (SESSION_TIER1USER === this.props.userType && isAccountDisabled(this.props.essoData)) 
                ?
                    <div className={(!this.props.smsOtpMessage?.info?.message && uuid2StepSuccess ) ?
                        classes.DisableLayerWithoutMessage : classes.DisableLayer}></div> : null}
                <GenerateOTP
                    essoData={this.props.essoData}
                    userType={this.props.userType}
                    generateOtpToken={this.props.generateOtpToken}
                    setOtpType={this.setOtpType}
                    setOtherFormDetails={this.setOtherFormDetails}
                    disableTab={(this.props.isOTPVerified && !(checkSuperUser(this.props.userType) || checkSuperVisorUser(this.props.userType))) || (uuid2StepFailed && SESSION_TIER1USER === this.props.userType) ? "-1" : "0"}
                />
                {verifyOtpForm}
                <Modal show={this.state.showModal} modalClosed={() => this.setState({ showModal: false })}
                modalContainerClass={classes.attestModalContainerClass}>
                    <div>
                        <div className={classes.attestModalText}>
                            I confirm that caller passed the 2-Step Process
                        </div>
                        <div className={classes.modalBtnContainer}>
                            <Button id="attestsuccess" btnType="AttestDialogBtn" type="button"
                                clicked={() => {
                                    this.setState({ showModal: false })
                                }}
                            >No</Button>
                            <Button id="attestsuccess" btnType="AttestDialogBtn" type="button"
                                clicked={() => {
                                    this.handleAttest(true)
                                }}
                            >Yes</Button>
                        </div>
                    </div>
                </Modal>
                {/* {errorMessage} */}
            </React.Fragment>
        );
    }
}

export default VerifyOTP;
